import { render } from "./TokenCard.vue?vue&type=template&id=1fb4fc59&scoped=true"
import script from "./TokenCard.vue?vue&type=script&lang=js"
export * from "./TokenCard.vue?vue&type=script&lang=js"

import "./TokenCard.vue?vue&type=style&index=0&id=1fb4fc59&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb4fc59"]])

export default __exports__